<script>
	import ExternalLink from './ExternalLink.svelte';
</script>

<style>

	.link-section {
        padding: var(--spacingXXLarge);
	}
	.link-content {
		display: flex;
		max-width: 1600px;
		justify-content: center;
		flex-wrap: wrap;
		margin: auto;
	}
	.link-name {
		font-weight: 800;
		text-decoration: underline;
	}
	.link-name:hover {
		color: var(--colorElementVariant);
	}
</style>
<div class="link-section">
	<div class="link-content">
		<ExternalLink hreflang="en" to="https://www.archives-pmr.org/action/showPdf?pii=S0003-9993%2806%2900443-6" src="/img/knaext.png"><br /><span class="link-name">Isometric muscle torque in children 5 to 15 years of age: normative data. Arch Phys Med Rehabil. 2006 Aug;87(8):1091-9. Eek MN, Kroksmark AK, Beckung E.</span></ExternalLink>
		<ExternalLink nolink hreflang="en" to="https://www.researchgate.net/profile/Meta-Eek/publication/5257064_Walking_ability_is_related_to_muscle_strength_in_children_with_cerebral_palsy/links/5787584308aeac8561de0f14/Walking-ability-is-related-to-muscle-strength-in-children-with-cerebral-palsy.pdf#read" src="/img/hoftext2.png"><br /><span class="link-name">Walking ability is related to muscle strength in children with cerebral palsy Gait & Posture. 2008 Oct;28(3):366-71. Eek MN, Beckung E.</span></ExternalLink>
	</div>
</div>